module.exports = __webpack_public_path__ + "media/fonts/Gotham Italic-3de1b843c5051c30b486eb82c66ba276.ttf";